import React from "react";

const Footer = () => {
    return (
        <div id="footer">
            <div className="footer-content">
                <p>
                    &copy; All rights reserved 2024. Developed by <span>Sahil Kumar</span>.
                </p>
            </div>
        </div>
    );
};

export default Footer;
